import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVideocamFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.24625 8.9975C2.24625 6.92643 3.92518 5.2475 5.99625 5.2475H13.0517C15.0295 5.2475 16.6498 6.7787 16.7916 8.72035L19.0848 7.30676C19.6249 6.97388 20.3027 6.95924 20.8566 7.26848C21.4105 7.57773 21.7538 8.16246 21.7538 8.79683V15.2032C21.7538 15.8375 21.4105 16.4223 20.8566 16.7315C20.3027 17.0408 19.6249 17.0261 19.0848 16.6932L16.7916 15.2797C16.6498 17.2213 15.0295 18.7525 13.0517 18.7525H5.99624C3.92517 18.7525 2.24625 17.0736 2.24625 15.0025V8.9975Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgVideocamFilled);
export default ForwardRef;
